// src/components/PilahSampah/PilahSampahGameplayScreen.js
import React, { useEffect } from 'react';
import styles from './PilahSampah.module.css';
import { ACTIONS } from './PilahSampahGame';

const PlayerPanel = ({ team, question, score, onAnswer, disabled, feedback }) => {
    const isGreen = team === 'green';
    const panelStyle = isGreen ? styles.green : styles.red;
    const title = isGreen ? 'Tim Hijau' : 'Tim Merah';
    const indicatorColor = isGreen ? '#4caf50' : '#f44336';

    return (
        <div className={`${styles.playerPanel} ${panelStyle}`}>
            <div className={styles.panelHeader}>
                <span className={styles.teamIndicator} style={{ backgroundColor: indicatorColor }}></span>
                <h3>{title}</h3>
            </div>
            <div className={styles.questionBox}><div className={styles.questionText}>{question?.text || '...'}</div></div>
            <div className={styles.scoreDisplay}>Skor: {score}</div>
            <div className={styles.categoryButtons}>
                <button className={styles.btnCategory} style={{background: '#4CAF50'}} onClick={() => onAnswer(team, 'organic')} disabled={disabled}>🌿 Organik</button>
                <button className={styles.btnCategory} style={{background: '#FF9800'}} onClick={() => onAnswer(team, 'inorganic')} disabled={disabled}>♻️ Anorganik</button>
                <button className={styles.btnCategory} style={{background: '#f44336'}} onClick={() => onAnswer(team, 'b3')} disabled={disabled}>☢️ B3</button>
            </div>
            {feedback && feedback.team === team && <div className={styles.feedbackPopup}>{feedback.isCorrect ? '✅' : '❌'}</div>}
        </div>
    );
};

// ... (Komponen Modal & Countdown jika diperlukan)

function PilahSampahGameplayScreen({ state, dispatch }) {
    // ==========================================================
    // PERBAIKAN DI SINI: Hapus 'difficulty' dari daftar ini
    // ==========================================================
    const { 
        greenScore, 
        redScore, 
        greenProgress, 
        redProgress, 
        currentGreenQuestion, 
        currentRedQuestion,
        winner,
        feedback
    } = state;
    
    // Efek untuk membersihkan feedback setelah beberapa saat
    useEffect(() => {
        if (feedback) {
            const timer = setTimeout(() => {
                dispatch({ type: ACTIONS.CLEAR_FEEDBACK });
            }, 1000); // Tampilkan feedback selama 1 detik
            return () => clearTimeout(timer);
        }
    }, [feedback, dispatch]);

    if (winner) {
        return (
             <div className={`${styles.modal} ${styles.active}`}>
                <div className={styles.modalContent}>
                    <div className={styles.modalTrophy}>🏆</div>
                    <h2>SELAMAT!</h2>
                    <p>Tim {winner === 'green' ? 'Hijau' : 'Merah'} Menang!</p>
                    <button className={`${styles.btn} ${styles.btnPrimary}`} onClick={() => dispatch({ type: ACTIONS.RESTART })}>Main Lagi</button>
                </div>
            </div>
        );
    }

    return (
        <div className={`${styles.screen} ${styles.gameScreen} ${styles.active}`}>
            <div className={styles.arenaContainer}>
                <div className={styles.pipetteContainer}>
                    <div className={styles.pipetteWrapper}>
                        <div className={styles.pipette}><div className={`${styles.pipetteLiquid} ${styles.green}`} style={{ height: `${greenProgress}%` }}></div></div>
                        <div className={styles.pipetteLabel}>{Math.round(greenProgress)}%</div>
                    </div>
                    <div className={styles.vsText}>VS</div>
                    <div className={styles.pipetteWrapper}>
                        <div className={styles.pipette}><div className={`${styles.pipetteLiquid} ${styles.red}`} style={{ height: `${redProgress}%` }}></div></div>
                        <div className={styles.pipetteLabel}>{Math.round(redProgress)}%</div>
                    </div>
                </div>
            </div>
            
              <div className={styles.interactionPanels}>
                <PlayerPanel team="green" question={currentGreenQuestion} score={greenScore} onAnswer={(team, answer) => dispatch({ type: ACTIONS.ANSWER, payload: { team, answer } })} disabled={!!feedback} feedback={feedback} />
                <PlayerPanel team="red" question={currentRedQuestion} score={redScore} onAnswer={(team, answer) => dispatch({ type: ACTIONS.ANSWER, payload: { team, answer } })} disabled={!!feedback} feedback={feedback} />
            </div>
        </div>
    );
}

export default PilahSampahGameplayScreen;